import { Navigate } from 'react-router-dom';
import { Spinner } from '@kollektive/design-system';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that only allows owners and admins to access.
 * Redirects members and viewers to the dashboard.
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const { canManageTeam, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (!canManageTeam) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
